// DashboardPanelFiltersReports - MODULE
// ***********************************************************************************************************************
/// <reference types="react-scripts" />
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Avatar, Box, Chip, Typography } from "@mui/material";
import * as React from "react";
import { FileType, ReportType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IListFilterItem } from "../../../models/common/listFilterItem";
import { IReportItem } from "../../../models/report/reportItem";
import { AttachmentIcon } from "../../attachments/AttachmentIcon";
import { CardContainer } from "../../framework/CardContainer";
import { DashboardCardTitle } from "../../framework/DashboardCard/DashboardCardTitle";
import { CircularLoading } from "../../framework/Loading/CircularLoading";
import { DashboardPanelNoReport } from "./DashboardPanelNoReport";

// DashboardPanelFiltersReports
export interface IDashboardPanelFiltersReportsProps {
    loading: boolean;
    title: string;
    filters: IListFilterItem[];
    reports: IReportItem[];
    noFiltersMessage: string;
    noReportsMessage: string;
    onFilterClick: (filterId: string) => void;
    onReportClick: (reportId: string) => void;
}

export class DashboardPanelFiltersReports extends React.Component<IDashboardPanelFiltersReportsProps, {}> {
    render() {
        const props = this.props;
        return (
            <>
                <DashboardCardTitle title={props.title} />
                <CardContainer>
                    {props.loading
                        ? (
                            <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                                <CircularLoading />
                            </Box>
                        )
                        : (
                            <>
                                <Box>
                                    <Typography variant="caption" color="#616d7c">{Translations.Filters}</Typography>
                                    {(!props.loading && props.filters.length < 1) &&
                                        <DashboardPanelNoReport
                                            title={props.noFiltersMessage}
                                        />
                                    }
                                    {props.filters.length > 0 &&
                                        <Box display="flex" flexWrap="wrap">
                                            {props.filters.map(filter =>
                                                <Chip
                                                    variant="outlined"
                                                    key={filter.id}
                                                    label={filter.getTitle()}
                                                    icon={<FilterAltOutlinedIcon />}
                                                    onClick={() => props.onFilterClick(filter.id)}
                                                    sx={{ margin: ".25rem .5rem .25rem 0" }}
                                                />
                                            )}
                                        </Box>
                                    }
                                </Box>
                                <Box marginTop=".75rem">
                                    <Typography variant="caption" color="#616d7c">{Translations.Reports}</Typography>
                                    {(!props.loading && props.reports.length < 1) &&
                                        <DashboardPanelNoReport
                                            title={props.noReportsMessage}
                                        />
                                    }
                                    {props.reports.length > 0 &&
                                        <Box display="flex" flexWrap="wrap" sx={{ marginBottom: "1rem" }}>
                                            {props.reports.map(report =>
                                                <Chip
                                                    variant="outlined"
                                                    key={report.id}
                                                    label={report.getTitle()}
                                                    onClick={() => props.onReportClick(report.id)}
                                                    sx={{ margin: ".25rem .5rem .25rem 0" }}
                                                    icon={
                                                        <Avatar sx={{ width: 24, height: 24, backgroundColor: "transparent" }}>
                                                            <AttachmentIcon fileType={report.type === ReportType.Html
                                                                ? FileType.Html
                                                                : (report.type === ReportType.Pdf
                                                                    ? FileType.Pdf
                                                                    : FileType.Excel
                                                                )} />
                                                        </Avatar>
                                                    }
                                                />
                                            )}
                                        </Box>
                                    }
                                </Box>
                            </>
                        )}
                </CardContainer>
            </>
        );
    }
}